export const COLUMN_IDS = {
    COMPANY: 'company',
    NETWORK_CAPTURE_RATE: 'networkCaptureRate',
    TOTAL_NETWORK_CAPTURE_RATE: 'totalNetworkCaptureRate',
} as const;

export const COLUMN_PREFIXES = {
    AIRPORT_ORDERS: 'airportOrders_',
    FBO_ORDERS: 'fboOrders_',
} as const;

export const SORT_PROPERTIES = {
    PRIMARY: 'networkCaptureRate',
    SECONDARY: 'company',
} as const;

export const PERCENTAGE_MULTIPLIER = 10000;
export const PERCENTAGE_DIVISOR = 100;


